export default {"src":"/_next/static/image/public/images/img_thanks.49628c1ae7d299247e32d3331d9b1146.svg","height":135,"width":128};